var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar_info_box",style:(_vm.varStyle)},[_c('div',{staticClass:"text_box"},[_vm._v(_vm._s(_vm.nub + _vm.unit))]),_c('div',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }